<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer__copyright">
        <p>Member of <a href="http://gsan.solar/" target="_about">GSAN solar</a></p>
        <p><a href="https://www.srh-hochschule-berlin.de/en/homepage/" target="_about">SRH Berlin University of Applied Sciences</a></p>
        <p class="margin-0">Copyright © 2020 All rights reserved</p>
      </div>
      <div class="footer__impressum">
        <router-link to="impressum">Impressum</router-link>
        <a href="https://www.facebook.com/solar.business.essentials" class="footer__impressum--social" target="_blank">
          <font-awesome-icon :icon="['fab', 'facebook-square']"></font-awesome-icon>
        </a>
        <a href="https://www.instagram.com/german.solar.academy.network/" class="footer__impressum--social" target="_blank">
          <font-awesome-icon :icon="['fab', 'instagram']"></font-awesome-icon>
        </a>
         <a href="https://www.linkedin.com/in/matthias-raab-2506ab8/" class="footer__impressum--social" target="_blank">
          <font-awesome-icon :icon="['fab', 'linkedin']"></font-awesome-icon>
        </a>
         <a href="https://www.xing.com/profile/Matthias_Raab10/cv" class="footer__impressum--social" target="_blank">
          <font-awesome-icon :icon="['fab', 'xing']"></font-awesome-icon>
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer',
};
</script>
